import { ElementRef, Injectable, ViewChild } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import { environment } from "../../../environments/environment";
import { RemittanceEntry } from "../../models/remittance-entry.model";
import { BaseService } from "../api-base.service";
import { GlobalFilterService } from "../global-filter.service";
import { ReconApiService } from "../recon-api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class CreateRemittanceService {
  private readonly Timeout: number = 30000;
  private readonly basePath: string = "Remittance";

  @ViewChild("button") createRemittanceButton: ElementRef;

  //  Observables
  private createRemittanceSource = new Subject<RemittanceEntry>();
  private updateRemittanceSource = new Subject<RemittanceEntry>();

  createRemittanceSource$ = this.createRemittanceSource.asObservable();
  updateRemittanceSource$ = this.updateRemittanceSource.asObservable();

  constructor(
    private globalFilterService: GlobalFilterService,
    private http: HttpClient,
    private apiBase: BaseService,
    private reconApiService: ReconApiService
  ) {}

  async createRemittance(remittance: RemittanceEntry) {
    //  Submit remittance entry to iSeries.
    await this.postRemittanceEntry(
      this.globalFilterService.selectedEnvironment.ClientId4Digit,
      remittance
    )
      .then(() => {
        //  Notify subscribers that a new Remittance Entry has been created.
        this.createRemittanceSource.next(remittance);
      })
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
      });
  }

  async updateRemittance(
    batchId: string,
    sequenceNum: number,
    remittance: RemittanceEntry
  ) {
    //  Update remittance entry to iSeries.
    await this.updateRemittanceEntry(
      this.globalFilterService.selectedEnvironment.ClientId4Digit,
      batchId,
      sequenceNum,
      remittance
    )
      .then(() => {
        //  Notify subscribers that a new Remittance Entry has been created.
        this.updateRemittanceSource.next(remittance);
      })
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
      });
  }

  //  Posts the remittance to the iSeries.
  private async postRemittanceEntry(
    clientId: string,
    remittance: RemittanceEntry
  ) {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/StageRemittances`;

    return this.http
      .post(
        url,
        remittance, // no need to JSON.stringify with HttpClient
        { headers: this.apiBase.getHeaders() }
      )
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
        // preserve the rejection so callers' .catch still fires
        throw error;
      });
  }

  //  Updates the remittance to the iSeries.
  private async updateRemittanceEntry(
    clientId: string,
    batchId: string,
    sequenceNum: number,
    remittance: RemittanceEntry
  ) {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/StageRemittances/Batch/${batchId}/Sequence/${sequenceNum}`;
    const response = await this.http
      .put(url, remittance, { headers: this.apiBase.getHeaders() })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/remittance-entry/create-remittance.service.ts